<template>
  <section class="chart-body">
    <section
      v-for="(data, index) in dataList"
      :key="index"
      class="chart-item"
    >
      <section class="chart-item-header">
        <span>{{data.name}}</span>
      </section>
      <section class="chart-item-body">
        <div style="padding-top: 5px;margin: auto;">
          <el-input size="small" type="number" v-model="data.min" style="width: 150px;" @input="dataListChange">
            <template slot="prepend">最低值</template>
          </el-input>
          <el-input size="small" type="number" v-model="data.max" style="width: 150px;" @input="dataListChange">
            <template slot="prepend">最高值</template>
          </el-input>
        </div>
        <div style="padding-bottom: 10px;">
          <key-line-chart
            ref="lineCharts"
            :data="{
              data: data.data,
              name: data.name,
              unit: data.unit,
              max: data.max,
              min: data.min,
              dataTimes: data.dataTimes
            }"
          />
        </div>
      </section>
    </section>
  </section>
</template>

<script>
import KeyLineChart from '../../../../components/Data/keylinechart'
export default {
  name: 'ParameterChart',
  props: {
    data: {
      required: true,
      type: Array
    },
    query: {
      required: true,
      type: Object
    },
    importanceDeviceStatusMap: {
      required: true,
      type: Object
    }
  },
  components: {KeyLineChart},
  data () {
    return {
      dataList: []
    }
  },
  methods: {
    dataListChange () {
      this.renderCharts()
    },
    formatStatusChartData (data, query) {
      let {statusIds} = query
      let {importanceDeviceStatusMap} = this
      if (!data.length) {
        this.dataList = statusIds.map(el => {
          if (importanceDeviceStatusMap[el] && importanceDeviceStatusMap[el].status) {
            return {
              name: importanceDeviceStatusMap[el] ? importanceDeviceStatusMap[el].statusName : '',
              unit: importanceDeviceStatusMap[el] ? importanceDeviceStatusMap[el].unit : '',
              data: [],
              max: importanceDeviceStatusMap[el].isAlarm ? (importanceDeviceStatusMap[el].alarmMax || '') : '',
              min: importanceDeviceStatusMap[el].isAlarm ? (importanceDeviceStatusMap[el].alarmMin || '') : '',
              dataTimes: []
            }
          }
        }).filter(Boolean)
        this.renderCharts()
        return
      }

      let dataMap = data.reduce((map, el) => {
        if (importanceDeviceStatusMap[el.deviceStatusId] && importanceDeviceStatusMap[el.deviceStatusId].status) {
          if (!map[el.deviceStatusId]) {
            map[el.deviceStatusId] = {
              name: importanceDeviceStatusMap[el.deviceStatusId] ? importanceDeviceStatusMap[el.deviceStatusId].statusName : '',
              unit: importanceDeviceStatusMap[el.deviceStatusId] ? importanceDeviceStatusMap[el.deviceStatusId].unit : '',
              data: [],
              max: importanceDeviceStatusMap[el.deviceStatusId].isAlarm ? importanceDeviceStatusMap[el.deviceStatusId].alarmMax : '',
              min: importanceDeviceStatusMap[el.deviceStatusId].isAlarm ? importanceDeviceStatusMap[el.deviceStatusId].alarmMin : '',
              dataTimes: []
            }
          }

          map[el.deviceStatusId].data.push(el.value)
          map[el.deviceStatusId].dataTimes.push(el.dataTime)
        }

        return map
      }, {})

      this.dataList = Object.values(dataMap).filter(Boolean)
      this.renderCharts()
    },
    renderCharts () {
      setTimeout(() => {
        let charts = this.$refs.lineCharts
        if (charts && charts.length > 0) {
          charts.forEach(el => {
            el.render()
          })
        }
      }, 10)
    }
  },
  watch: {
    data (val) {
      if (val.length >= 0 && this.query) {
        this.formatStatusChartData(val, this.query)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-body {
  width: 100%;
  height: 100%;
  padding-top: 10px;
  overflow: auto;
}

.chart-item-header {
  width: 100%;
  line-height: 1.8em;
  padding: 0 10px;
  text-align: center;
  font-weight: 600;
}

.chart-item-body {
  height: 550px;
  display: grid;
  grid-template-rows: 10% 90%;
  gap: 5px;
}
.el-date-editor {
  width: 165px;
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditDeviceViews/AuditKeyParameterChart.vue